// Cart JS
class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.cartCount = document.querySelectorAll('[data-cart-count]');
    this.isOpen = false;
    this.isLoading = false;
    this.errorTimeout = null;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.updateCartCount();
  }

  bindEvents() {
    // Open drawer events
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-drawer-open]')) {
        e.preventDefault();
        this.open();
      }
    });
    
    // Close drawer events
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-drawer-close]') || 
          e.target.closest('[data-cart-drawer-close]')) {
        e.preventDefault();
        this.close();
      }
    });
    
    // Add to cart form submission
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });
    
    // Cart update events
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-update]') || 
          e.target.closest('[data-cart-update]')) {
        e.preventDefault();
        const button = e.target.closest('[data-cart-update]');
        // Use line item key if available, otherwise fall back to variant ID
        const itemId = button.dataset.lineKey || button.dataset.variantId;
        this.updateCart(itemId, button.dataset.quantity);
      }
    });
    
    // Cart remove events
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-cart-remove]') || 
          e.target.closest('[data-cart-remove]')) {
        e.preventDefault();
        const button = e.target.closest('[data-cart-remove]');
        // Use line item key if available, otherwise fall back to variant ID
        const itemId = button.dataset.lineKey || button.dataset.variantId;
        this.updateCart(itemId, 0);
      }
    });
    
    // Quantity input changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-cart-quantity-input]')) {
        const input = e.target;
        const quantity = parseInt(input.value) || 0;
        // Use line item key if available, otherwise fall back to variant ID
        const itemId = input.dataset.lineKey || input.dataset.variantId;
        this.updateCart(itemId, quantity);
      }
    });
    
    // Keyboard events
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
    
    // Custom cart events
    document.addEventListener('cart:added', () => {
      this.open();
    });
    
    document.addEventListener('cart:updated', () => {
      this.refreshDrawer();
    });

    // Clear cart event
document.addEventListener('click', (e) => {
  if (e.target.matches('[data-cart-clear]') || 
      e.target.closest('[data-cart-clear]')) {
    e.preventDefault();
    this.clearCart();
  }
});
  }
  
  async addToCart(form) {
    if (this.isLoading) return;
    
    // Get the submit button or form to add loading class
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]') || form;
    
    this.setLoading(true);
    this.setButtonLoading(submitButton, true);
    
    try {
      const formData = new FormData();
      const idInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      // Add required fields
      if (idInput && idInput.value) {
        formData.append('id', idInput.value);
      } else {
        throw new Error('Product variant ID is required');
      }
      
      const quantity = parseInt(quantityInput?.value || '1') || 1;
      formData.append('quantity', quantity.toString());

      // Optional: Add selling_plan if exists
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        formData.append('selling_plan', sellingPlanInput.value);
      }
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const item = await response.json();
        this.showSuccess(`Added ${item.title || 'item'} to cart`);
        this.refreshDrawer();
        this.open();
        
        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
      } else {
        const error = await response.json();
        this.showError(error.description || error.message || 'Failed to add item to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      this.showError(error.message || 'Failed to add item to cart');
    } finally {
      this.setLoading(false);
      this.setButtonLoading(submitButton, false);
    }
  }
  
  async updateCart(itemId, quantity) {
    if (this.isLoading) return;
    
    this.setLoading(true);
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: itemId, // This can be either variant ID or line item key
          quantity: quantity
        })
      });
      
      if (response.ok) {
        const cart = await response.json();
        this.refreshDrawer();
        this.updateCartCount();
        
        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } else {
        const error = await response.json();
        this.showError(error.description || error.message || 'Failed to update cart');
      }
    } catch (error) {
      console.error('Update cart error:', error);
      this.showError('Failed to update cart');
    } finally {
      this.setLoading(false);
    }
  }
  
  async refreshDrawer() {
    try {
      const response = await fetch('/cart?view=drawer', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('cart-drawer');
        
        if (newDrawer && this.drawer) {
          this.drawer.innerHTML = newDrawer.innerHTML;
          this.updateCartCount();
          // initUpsellSlider();
        }
      }
    } catch (error) {
      console.error('Refresh drawer error:', error);
    }
  }
  
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (response.ok) {
        const cart = await response.json();
        this.cartCount.forEach(element => {
          element.textContent = cart.item_count || '0';
        });
      }
    } catch (error) {
      console.error('Update cart count error:', error);
    }
  }
  
  open() {
    if (!this.drawer) {
      console.warn('Cart drawer element not found');
      return;
    }
    
    this.drawer.classList.add('is-open');
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
    
    // Focus trap
    const focusableElements = this.drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }
  
  close() {
    if (!this.drawer) return;
    
    this.drawer.classList.remove('is-open');
    this.isOpen = false;
    document.body.style.overflow = '';
  }
  
  setLoading(loading) {
    if (!this.drawer) return;
    
    this.isLoading = loading;
    if (loading) {
      this.drawer.classList.add('cart-drawer--loading');
    } else {
      this.drawer.classList.remove('cart-drawer--loading');
    }
  }
  
  setButtonLoading(button, loading) {
    if (!button) return;
    
    if (loading) {
      button.classList.add('loading');
      button.disabled = true;
    } else {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  showSuccess(message) {
    // You can implement a toast notification here
    console.log('Success:', message);
  }
  
  showError(message) {
    console.error('Error:', message);
    
    // Find error message element
    const errorElement = document.querySelector('.error-msg');
    if (errorElement) {
      // Clear any existing timeout
      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
      }
      
      // Show the error message
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      
      // Remove after 5 seconds
      this.errorTimeout = setTimeout(() => {
        errorElement.style.display = 'none';
        errorElement.textContent = '';
      }, 5000);
    } else {
      // Fallback if no .error-msg element found
      alert(message);
    }
  }

  // Clear Cart
async clearCart() {
  if (this.isLoading) return;

  this.setLoading(true);

  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (response.ok) {
      const cart = await response.json();
      this.refreshDrawer();
      this.updateCartCount();

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } else {
      const error = await response.json();
      this.showError(error.description || error.message || 'Failed to clear cart');
    }
  } catch (error) {
    console.error('Clear cart error:', error);
    this.showError('Failed to clear cart');
  } finally {
    this.setLoading(false);
  }
}


}

// Initialize cart drawer when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
});

// Export for use in other scripts if needed
if (typeof window !== 'undefined') {
  window.CartDrawer = CartDrawer;
}